export const formatNumber = (input: any): string => {
  return Number(input).toFixed(2);
};
